module.exports = __webpack_public_path__ + "images/44bb0ac4c31bbfd6b75c5f59f6407fa2.gif";